// Copyright (c) Docugami, Inc. All rights reserved.

import { Checkbox, ChoiceGroup, IChoiceGroupOption, SelectionMode, Stack } from "@fluentui/react";
import styled from "styled-components";

const ChoiceOptionRoot = styled.div`
    width: 100%;
`;

const Divider = styled.div`
    border-bottom: 1px solid black;
    margin-bottom: 10px;
    width: 100%;
`;

export interface IChooserItem {
    id: string;
    label: string;
}

interface ChooserListProps {
    items: IChooserItem[];
    selectionMode: SelectionMode;
    selectedItems: string[];
    onSelectionChanged: (selectedItems: string[] | undefined) => void;
}

export const ChooserList = (props: ChooserListProps) => {
    const { items, selectedItems, selectionMode, onSelectionChanged } = props;

    function onChangeItemSelection(item: IChooserItem, checked?: boolean) {
        const newSelection = !checked ? selectedItems?.filter(x => x !== item.id) : [...(selectedItems ?? []), item.id];
        onSelectionChanged(newSelection);
    }

    if (selectionMode === SelectionMode.multiple) {
        return <Stack tokens={{ childrenGap: 10 }}>
            {
                items.map((item, index) => (
                    <Stack.Item key={item.id}>
                        {index !== 0 && <Divider />}
                        <Checkbox
                            key={item.id}
                            label={item.label.toLocaleUpperCase()}
                            checked={selectedItems?.includes(item.id)}
                            onChange={(ev, checked) => onChangeItemSelection(item, checked)} />
                    </Stack.Item>
                ))
            }
        </Stack>

    }
    else {
        const options: IChoiceGroupOption[] = items.map((item, index) => ({
            key: item.id,
            text: item.label.toLocaleUpperCase(),
            styles: { choiceFieldWrapper: { width: '100%' } },
            onRenderField: (props, defaultRender) => {
                return (
                    <ChoiceOptionRoot>
                        {index !== 0 && <Divider />}
                        {defaultRender?.(props)}
                    </ChoiceOptionRoot>
                )
            }
        }))

        return <ChoiceGroup
            selectedKey={selectedItems?.[0]}
            options={options}
            onChange={(ev, option) => onSelectionChanged(!option ? undefined : [option.key])}
            label="Pick a doc set"
            required={true} />
    }
}